import { createContext } from 'react';
export var RcSubMenuContext = createContext({
    autoClose: false,
    closeSubMenu: undefined,
});
